module.exports = __webpack_public_path__ + "img/5220e06.svg";